export const translationsObject = {
  en: {
    srcIframe:
      'https://app.powerbi.com/view?r=eyJrIjoiYmE4NDg5OTQtOTFmOC00MjljLTk2MzEtYTAxMmIxNmJjYjhkIiwidCI6IjU1ZDhhNjVkLTc3MDMtNGZhNy1hMTNmLThkNGQzMGZhZmE0ZCIsImMiOjR9',
    application: {
      Ingles: 'English',
      Español: 'Spanish',
      portugues: 'portugues',
      ShowMore: 'Show More',
      showLess: 'show Less',
      CreateCampaign: 'Create Campaign',
      titleAdmin: 'Admin  tling v1.6.15',
      title: 'ACME company',
      email: 'email',
      SignOff: 'Sign Off',
      LogIn: 'Log in',
      mainManu: {
        dashboard: 'Dashboard',
        campaigns: 'Campaigns',
        users: 'Users',
        payments: 'Payments',
        Groups: 'Groups',
        DetailGroups: 'Group detail',
        Suppliers: 'Suppliers',
        Setings: 'Settings',
        campaignsSave: 'Draft',
        scheduledCampaigns: 'Scheduled',
        categories: 'Categories',
      },
      changePassword: 'Change Password',
      DashboardCampañas: 'Dashboard campaigns',
      yes: 'Yes',
    },
    changePassword: {
      changePassword: 'Change password',
      text: 'In this section you can change your password to a new one.',
      previousPassword: 'Enter the previous password',
      requireMesage: 'Please enter the data',
      newPassword: 'Enter the new password',
      RepeatPassword: 'Repeat the new password',
      save: 'Save new password',
      inconsistentPass: 'Two passwords that you enter is inconsistent!',
      alertSuccess: 'The password was changed correctly',
      errorSeve: 'There was an error when changing the password, try again.',
    },
    DashboardTling: {
      Efectividad: 'Effectiveness',
      PaymentsByDate: 'Payments by Date',
      Bells: 'Campaigns',
      TotalCampaignsOfTheMonth: 'Total campaigns of the month',
      TotalCampaignsFromTheStart: 'Total campaigns from the start of the year to the current date',
      Points: 'Points',
      PointsDelivered: 'Earned',
      TotalPointsEarnedFromMonth: 'Total points earned from month',
      TotalPointsEarnedFromTheBeginning:
        'Total points earned from the beginning of the year to the current date',
      RedeemedPoints: 'Redeemed',
      TotalPointsRedeemedFromMonth: 'Total points redeemed from month',
      TotalPointsRedeemedFromTheBeginning:
        'Total points redeemed from the beginning of the year to the current date',
      TotalPaidInvoicesOfTheMonth: 'Total paid invoices of the month',
      Invoices: 'Invoices',
      Activeusers: 'Active Users',
      NoActiveusers: 'Inactive Users',
      TotalInvoicesPaidFromTheBeginning:
        'Total invoices paid from the beginning of the year to the current date',
      TotalBill: 'Total Points to Pesos Spended by Day',
      TotalPaidWithMoney: 'Total Points Spended by Day',
      TotalPaidWithPoints: 'Total Points Earned by Day',
      TotalCampaigns: 'Total campaigns',
      TotalPointsEarned: 'Total points earned',
      TotalPointsRedeemed: 'Total points redeemed',
      TotalInvoices: 'Number of Invoices',
      TotalInvoices2: 'Total Invoices',
      days: {
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        Sunday: 'Sunday',
      },
      typeSurvey: 'Type of Campaign',
      tableOne: {
        position: 'position',
        name: 'Name',
        Effectiveness: 'Effectiveness',
      },
    },
    SurveysAdmin: {
      helmetTitle: 'Usuarios',
      ListOfCampaigns: 'List of Campaigns',
      FilterByType: 'Filter by Type',
      FilterByTypeDivision: 'Filter by Cost Center',
      filter: {
        none: 'None',
        all: 'All',
        Survey: 'Survey',
        Training: 'Training',
      },
      FilterByDateRange: 'Filter by Date Range',
      FilterByDateRangeStartEnd: 'Filter by start date and end date',
      filterData: {
        select: 'Select ...',
        currentMonth: 'Current month',
        currentYear: 'Current year',
        eight: 'Last 8 Days',
        thirty: 'Last 30 Days',
        ninety: 'Last 90 Days',
        eighty: 'Last 180 Days',
        one: 'Last year',
        personalized: 'personalized',
      },
      filterText: 'Filter',
      NewCampaign: 'New Campaign',
      NewCampaign2: 'New template',
      NewCampaign3: 'Campaign saved',
      NewCampaign4: 'Template',
      NewCampaign5: 'New Campaign',
      NewCampaign8: 'Scheduled Campaign',
      TypeOfCampaign: 'Type of Campaign',
      photoWithLocationPhoto: 'Type',
      Equivalencia: 'Equivalence: ',
      publishType: 'Type of Publication',
      group: 'Group',
      name: 'Campaign Name',
      Description: 'Description',
      Budget: 'Points Budget',
      ValuePerResponse: 'Value for Response in Points',
      UploadCampaignIcon: 'Upload campaign icon',
      UploadNewCampaignIcon: 'Change campaign icon',
      UploadFileForContent: 'Upload file for content',
      UploadFileForQuestion: 'Upload image for the question',
      expirationDate: 'Expiration date: ',
      PublishDate: 'Publish Date: ',
      daysPublish: 'Days of Publication',
      Questions: 'Questions',
      Contents: 'Contents',
      NewQuestion: 'New Question',
      SaveCampaign: 'Save campaign',
      Cancel: 'Cancel',
      PreguntaNumber: 'Question',
      Content: 'Content',
      EnterQuestion: 'Enter a question',
      text1: 'Text',
      TypeOfResponse: 'Type of Response',
      TypeOfContent: 'Type of content',
      typeQuestion: {
        MultiOption: 'Multiple option',
        SingleOption: 'Single option',
        Text: 'Text response',
        Number: 'Numerical answer',
        Phone: 'Phone number',
        Image: 'Image',
        TextM: 'Text',
      },
      save: 'save',
      tableNames: {
        type: 'type',
        name: 'Name',
        DateOfExpiry: 'Date of Expiration',
        Budget: 'Budget',
        RemainingBudget: 'Remaining Rudget',
        EarnPoints: 'Earn points',
        equivalenceMoney: 'equivalence in money',
      },
      training: 'training',
      Survey: 'Survey',
      DetailOfTheBalance: 'Detail of the balance',
      detailSurvey: {
        Updated: 'Updated',
        name: 'Name',
        phoneNumber: 'Phone number',
      },
      detailTable: {
        Updated: 'Updated',
        image: 'Image',
        name: 'Name',
        TotalPoints: 'Total points',
      },
      NewAnswer: 'Add a new answer',
      saveLocalStorage: 'Do you want to save the campaign to continue later?',
      continueCampaign: 'Continue the previously created campaign?',
      errorSave: 'There must be at least two options',
      errorSave2: 'Error must enter all data.',
      errorSave3: 'Error must save all questions before saving the campaign.',
      errorSave4: 'Error the campaign could not be saved',
      errorSave5: 'The publication date should not be longer than the expiration date',
      errorSave6: 'Wait while you finish loading the image...',
      errorSave7: 'You must select the correct answer.',
      errorSave8: 'You must select the correct answers.',
      errorSave9: 'You must upload a file, photo, video, etc.',
      messageResponse: 'Select the correct answer',
      errorDeleteQuestion: 'There must be a minimum question',
      errorDeleteOption: 'There must be at least two types of response',
      confirmDeleteOption: 'Are you sure you want to eliminate this response?',
      confirmDeleteQuestion: 'Are you sure to delete this question?',
      sendCampaing: 'Are you sure you save the campaign?',
      successMessage: 'The campaign was saved correctly',
      detailCampaigns: 'Campaign detail',
      UsersWhoHaveAnswered: 'Users Who Have Answered',
      ActiveUsers: 'Active users during the survey: ',
      originalImage: 'original image',
      userResponses: 'User Responses',
      listOfAnswers: 'List of answers',
      responseMap: 'Response map',
      listUsers: 'List of users who answered the survey',
      load: 'Loading...',
      responses: 'Answers',
      listType: {
        Survey: 'Survey',
        Form: 'Form',
        Training: 'Training',
        Announcement: 'Announcement',
        PhotoWithLocation: 'Photo with location',
        none: 'none',
      },
      listDivision: {
        Marketing: 'Marketing',
        Sales: 'Sales',
        Finance: 'Finance',
      },
      filterByName: 'Filter by Name',
      listTypePublish: {
        Post: 'Post',
        postNow: 'Post Now',
        SchedulePublication: 'Schedule Publication',
        SaveDraft: 'Save Draft',
        SaveTemplate: 'Save Template',
        periódicamente: 'Periodically',
        save: 'Save',
      },
      SelectSavedCampaign: 'Select Saved Campaign',
      SelectTemplate: 'Select a Template',
      radioSelect: {
        1: 'Create new campaign',
        2: 'Create a template',
        3: 'Create campaign based on a template',
        4: 'Continue with a saved campaign',
      },
      existeImage: 'An Image for this campaign already exists',
      TotalsInPoints: 'Total Points',
      TotalsInMoney: 'Total in Money',
      EarnPoints: 'Earn points: ',
      WithFaceRecognition: 'With face recognition',
      WithIDRecognition: 'With ID recognition',
      WithoutFaceRecognition: 'Without cognitive services',
      SelectImageFace: 'Upload image of human face',
      errorImage: {
        one: 'The image is not a face',
        two: 'There must be only one face in the image',
      },
      idendifiedPercentage: 'Idendified Percentage',
      isIdendified: 'is idendified',
      daysJson: {
        1: 'Every Day',
        2: 'Every 2 Days',
        3: 'Every 3 Days',
        4: 'Every 4 Days',
        5: 'Every 5 Days',
        6: 'Every 6 Days',
        7: 'Every 7 Days',
        8: 'Every 8 Days',
        9: 'Every 9 Days',
        10: 'Every 10 Days',
        11: 'Every 11 Days',
        12: 'Every 12 Days',
        13: 'Every 13 Days',
        14: 'Every 14 Days',
        15: 'Every 15 Days',
        16: 'Every 16 Days',
        17: 'Every 17 Days',
        18: 'Every 18 Days',
        19: 'Every 19 Days',
        20: 'Every 20 Days',
        21: 'Every 21 Days',
        22: 'Every 22 Days',
        23: 'Every 23 Days',
        24: 'Every 24 Days',
        25: 'Every 25 Days',
        26: 'Every 26 Days',
        27: 'Every 27 Days',
        28: 'Every 28 Days',
        29: 'Every 29 Days',
        30: 'Every 30 Days',
        31: 'Every 31 Days',
      },
      successBien: 'The campaign was deleted correctly.',
    },
    users: {
      typeMessage1: 'file uploaded successfully.',
      typeMessage2: 'file upload failed.',
      SelectGroup: 'Select the group',
      addUsersByCsv: 'Upload Users by CSV',
      titleModal: 'Add Users by CSV',
      modalMessageOne: 'Click or drag file to this area to upload',
      modalMessageTwo: 'Upload only CSV files',
      filterByDate: 'Filter by Active Users',
      ListOfUsers: 'List of Users',
      points: 'Points',
      Detail: 'Detail',
      tableNames: {
        access: 'Access',
        Registry: 'Registry',
        name: 'Name',
        Telephone: 'Telephone',
        status: 'Status',
      },
      enterpriseFilter: 'Filter by Company',
      edit: 'Edit',
    },
    Payments: {
      PaidOrders: 'Paid Orders:',
      TotalValuePaid: 'Total Value Paid',
      AverageValuePaid: 'Average Value Paid',
      ListOfTransactions: 'List of Transactions',
      WithCard: 'With card',
      WithPoints: 'With points',
      tableNames: {
        amount: 'Total',
        invoiceNumber: 'Invoice Number',
        invoiceStatus: 'Invoice Status',
        payed_points: 'Points',
        payed_money: 'Amount',
      },
      FilterByInvoiceNumber: 'Filter by Invoice Number',
      error: 'There is no invoice number',
      printScv: 'Export CSV',
    },
    groupsDetail: {
      Campaigns_in_the_group: 'Campaigns in the group',
      ListOfGroups: 'List of Groups',
      TotalCampaigns: 'Total campaigns',
      TotalUsers: 'Total users',
      tableNames: {
        name: 'Name',
        type: 'Type',
        createdAt: 'Created at',
        expiration_date: 'Expiration date',
        budget: 'Budget',
        budget_remaining: 'Budget remaining',
        earn_points: 'Earn points',
        suscribers_answered: 'Suscribers answered',
        number_of_suscribers_in_group: 'Number of Suscribers in Group',
        updatedAt: 'Updated at',
        status: 'Status',
        campaing: 'Campaigns',
      },
      total_suscribers_answered_by_group: 'Total answers by group',
      total_campaigns_by_group: 'total campaigns by group',
      filterByGroup: 'Filter by group',
      NewGroup: 'Add Group',
      addUsers: 'Add Users',
      downloadUsers: 'Download list of users in CSV',
      detail: 'Detail',
      addKaizalaID: 'Add group from kaizala',
      selectID: 'please select an option',
      addKaizalaGroup: 'Group',
      campaing: 'Campaigns',
      AddMiniAppTitle: 'Add miniApp to the group',
      AddMiniAppButton: 'Add MiniApp',
      selectMiniApp: 'Select the miniApp',
      invoice: 'Bill Payment',
      errorAddMiniApp: 'You must select a miniApp to add it to the group.',
      add: 'Add',
      addMiniappSuccess: 'The miniApp was successfully added to the group.',
      addMiniappError: 'There was an error trying to add the miniApp to the group.',
    },
    addGroup: {
      GroupName: 'Group Name',
      briefDescription: 'brief description',
      LongDescription: 'Long description',
      WelcomeMessage: 'Welcome message',
      requireMesage: 'Please enter the data',
      Register: 'Register',
      UploadIcon: 'Upload group icon',
      SelectIcon: 'Select an image',
      errorImage: 'You must select an image for the group icon',
      success: 'The new gupo has been added successfully',
    },
    addUser: {
      success: 'The user was successfully added',
      errorMessage: 'The group is not public, you can not add users.',
      title: 'Add Users',
      save: 'Save',
      Number: 'Number Phone',
      required: 'Please input your phone number!',
      addKaizalaIdSuccess: 'The id of kaizala was added successfully.',
      codigoZap: 'Zap code',
    },
    SuppliersPage: {
      companyListing: 'company listing',
      tableNames: {
        name: 'Name',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
      },
    },
    createSuppliers: {
      addProvider: 'Add a provider',
      providerName: 'Name',
      requireMesage: 'Please enter the data',
      Register: 'Register',
      notValidEmail: 'The input is not valid E-mail!',
      enterpriseName: 'Enterprise Name',
      UploadIcon: 'Upload enterprise icon',
      selectIcon: 'Select an image',
      success: 'I have created the company successfully',
      errorImage: 'You must select an image for the company icon',
    },
    division: {
      title: 'Cost Center',
      title2: 'Cost Center',
      addDivision: 'Add',
      modal: {
        save: 'Save',
        nameDivision: 'Name',
      },
      successMessage: 'The was saved correctly',
      errorSeve: 'There was an error saving, try again.',
    },
    setings: {
      title: 'Settings',
      pointEquivalence: 'Point Equivalence',
      filterDefault: 'Default Filter',
      changeFilter: 'Change Filter',
      Points: 'Points',
      save: 'Save',
      titleModal: 'Edit Value of Equivalence',
      Register: 'Change Equivalence',
      filter: 'Filter',
      notHaveOneByDefault: 'You do not have one by default',
      text1: 'One Point Equals: ',
    },
    templates: {
      title: 'List of Templates',
      titleSaveCampaing: 'List of Saved Campaigns',
      titleScheduledCampaigns: 'List of Scheduled Campaigns',
      tableNames: {
        name: 'Name',
        createdAt: 'Created At',
        type: 'Type',
        publish_date: 'Publish date',
        hours: 'Hour',
        division: 'Cost Center',
      },
      deleteTemplate: 'Do you want to delete this template?',
      deleteSaveCampaing: 'Do you want to delete this Saved Campaign?',
    },
    categories: {
      title: 'Categories List',
      add: 'Create Category',
      form: {
        name: 'Name',
        points: 'Points',
        errorRequired: 'This data is required.',
      },
      successMessage: 'The category was saved correctly',
      category: 'Category',
      addUserToCategory: 'Add Category',
      editCategory: 'Edit Category',
      addCategoryByUser: 'Add Category to User',
      SuccessMessage: 'The category was added successfully',
      errorMessage: 'At this time the category cannot be added, try later.',
    },
  },
  es: {
    srcIframe:
      'https://app.powerbi.com/view?r=eyJrIjoiYzA3MTJhZTQtMmM0ZC00MTRhLThjNTAtMTM5ZWRmNjY2ZjJiIiwidCI6IjU1ZDhhNjVkLTc3MDMtNGZhNy1hMTNmLThkNGQzMGZhZmE0ZCIsImMiOjR9',
    application: {
      Ingles: 'Ingles',
      Español: 'Español',
      portugues: 'portugues',
      ShowMore: 'Mostrar Más',
      showLess: 'Mostrar Menos',
      CreateCampaign: 'Crear campaña',
      titleAdmin: 'Admnistrador  tling v1.6.15',
      title: 'Compañía ACME',
      email: 'Correo',
      SignOff: 'Cerrar sesión',
      LogIn: 'Iniciar sesión',
      mainManu: {
        dashboard: 'Dashboard',
        campaigns: 'Campañas',
        users: 'Usuarios',
        payments: 'Pagos',
        Groups: 'Grupos',
        DetailGroups: 'Detalle del grupo',
        Suppliers: 'Proveedores',
        Setings: 'Ajustes',
        campaignsSave: 'Borrador',
        scheduledCampaigns: 'Programadas',
        categories: 'Categorias',
      },
      changePassword: 'Cambiar contraseña',
      DashboardCampañas: 'Dashboard Campañas',
      yes: 'Si',
    },
    changePassword: {
      changePassword: 'Cambiar contraseña',
      text: 'En esta sección puedes cambiar tu contraseña por una nueva.',
      previousPassword: 'Ingresa la contraseña anterior',
      requireMesage: 'Por favor ingrese los datos',
      newPassword: 'Ingresa la nueva contraseña',
      RepeatPassword: 'Repite la nueva contraseña',
      save: 'Guardar nueva contraseña',
      inconsistentPass: '¡Las dos contraseñas que ingresas son inconsistentes!',
      alertSuccess: 'Se cambio la contraseña correctamente',
      errorSeve: 'hubo un error al cambiar la contraseña, intente nuevamente.',
    },
    DashboardTling: {
      Efectividad: 'Efectividad',
      PaymentsByDate: 'Pagos por Fecha',
      Bells: 'Campañas',
      TotalCampaignsOfTheMonth: 'Total de campañas del més',
      TotalCampaignsFromTheStart: 'Total de campañas desde el inicio del año a la fecha actual',
      Points: 'Puntos',
      PointsDelivered: 'Entregados',
      TotalPointsEarnedFromMonth: 'Total de puntos ganados del més',
      TotalPointsEarnedFromTheBeginning:
        'Total de puntos ganados desde el inicio del año a la fecha actual',
      RedeemedPoints: 'Redimidos',
      TotalPointsRedeemedFromMonth: 'Total de puntos redimidos del més',
      TotalPointsRedeemedFromTheBeginning:
        'Total de puntos redimidos desde el inicio del año a la fecha actual',
      TotalPaidInvoicesOfTheMonth: 'Total de facturas pagadas del més',
      Invoices: 'Facturas',
      Activeusers: 'Usuarios Activos',
      NoActiveusers: 'Usuarios Inactivos',
      TotalInvoicesPaidFromTheBeginning:
        'Total de facturas pagadas desde el inicio del año a la fecha actual',
      TotalBill: 'Total de puntos a pesos gastados por día.',
      TotalPaidWithMoney: 'Puntos totales gastados por día',
      TotalPaidWithPoints: 'Puntos totales ganados por día',
      TotalCampaigns: 'Total de campañas',
      TotalPointsEarned: 'Total de puntos ganados',
      TotalPointsRedeemed: 'Total de puntos redimidos',
      TotalInvoices: 'Número de Facturas',
      TotalInvoices2: 'Total de Facturas',
      days: {
        Monday: 'Lunes',
        Tuesday: 'Martes',
        Wednesday: 'Miércoles',
        Thursday: 'Jueves',
        Friday: 'Viernes',
        Saturday: 'Sábado',
        Sunday: 'Domingo',
      },
      typeSurvey: 'Tipo de Campaña',
      tableOne: {
        position: 'Posición',
        name: 'Nombre',
        Effectiveness: 'Efectividad',
      },
    },
    SurveysAdmin: {
      helmetTitle: 'Usuario',
      ListOfCampaigns: 'Listado de Campañas',
      FilterByType: 'Filtro por Tipo',
      FilterByTypeDivision: 'Filtro por Centro de Costo',
      filter: {
        none: 'Ninguno',
        all: 'Todas',
        Survey: 'Encuesta',
        Training: 'Entrenamiento',
      },
      FilterByDateRange: 'Filtro por Rango de Fecha',
      FilterByDateRangeStartEnd: 'Filtrar por fecha de inicio y fecha final',
      filterData: {
        select: 'Seleccione...',
        currentMonth: 'Mes en curso',
        currentYear: 'Año en curso',
        eight: 'Últimos 8 Días',
        thirty: 'Últimos 30 Días',
        ninety: 'Últimos 90 Días',
        eighty: 'Últimos 180 Días',
        one: 'Último año',
        personalized: 'Personalizado',
      },
      filterText: 'Filtrar',
      TypeOfCampaign: 'Tipo de Campaña',
      photoWithLocationPhoto: 'Tipo',
      Equivalencia: 'Equivalencia: ',
      publishType: 'Tipo de publicación',
      NewCampaign: 'Nueva Campaña',
      NewCampaign2: 'Nuevo template',
      NewCampaign3: 'Campaña guardada',
      NewCampaign4: 'template',
      NewCampaign5: 'Nueva Campaña',
      NewCampaign8: 'Camapaña Programada',
      group: 'Grupo',
      name: 'Nombre Campaña',
      Description: 'Descripción',
      Budget: 'Presupuesto en puntos',
      ValuePerResponse: 'Valor por respuesta en puntos',
      UploadCampaignIcon: 'Subir icono de la campaña',
      UploadNewCampaignIcon: 'Cambiar icono de la campaña',
      UploadFileForContent: 'Subir archivo para el contenido',
      UploadFileForQuestion: 'Subir imagen para la pregunta',
      expirationDate: 'Fecha de vencimiento: ',
      PublishDate: 'Dias de Publicación',
      daysPublish: 'Days of Publication: ',
      Questions: 'Preguntas',
      Contents: 'Contenidos',
      NewQuestion: 'Nueva Pregunta',
      SaveCampaign: 'Guardar campaña',
      Cancel: 'Cancelar',
      PreguntaNumber: 'Pregunta',
      Content: 'Contenido',
      EnterQuestion: 'Ingrese una pregunta',
      text1: 'Texto',
      TypeOfResponse: 'Tipo de respuesta',
      TypeOfContent: 'Tipo de contenido',
      typeQuestion: {
        MultiOption: 'Opción multiple',
        SingleOption: 'Opción Unica',
        Text: 'Respuesta de texto',
        Number: 'Respuesta numérica',
        Phone: 'Número de teléfono',
        Image: 'Imagen',
        TextM: 'Texto',
      },
      save: 'Guardar',
      tableNames: {
        type: 'Tipo',
        name: 'Nombre',
        DateOfExpiry: 'Fecha de Caducidad',
        Budget: 'Presupuesto',
        RemainingBudget: 'Presupuesto Restante',
        EarnPoints: 'Gana Puntos',
        equivalenceMoney: 'Equivalencia en Dinero',
      },
      training: 'Entrenamiento',
      Survey: 'Encuestas',
      DetailOfTheBalance: 'Detalle del balance',
      detailSurvey: {
        Updated: 'Actualizado',
        name: 'Nombre',
        phoneNumber: 'Número de teléfono',
      },
      detailTable: {
        Updated: 'Actualizado',
        image: 'Imagen',
        name: 'Nombre',
        TotalPoints: 'Total puntos ',
      },
      NewAnswer: 'Añadir una nueva respuesta',
      saveLocalStorage: '¿Desea guardar la campaña para continuar más tarde?',
      continueCampaign: 'Continuar la campaña previamente creada',
      errorSave: 'Tiene que haber al menos dos opciones',
      errorSave2: 'Error debe ingresar todos los datos.',
      errorSave3: 'Error debe guardar todas las preguntas antes de guardar la campaña.',
      errorSave4: 'Error no se pudo guardar la campaña.',
      errorSave5: 'La fecha de publicacion no debe ser mayor a la fecha de vencimiento',
      errorSave6: 'Espera mientras termina de cargar la imagen...',
      errorSave7: 'Debe seleccionar la respuesta correcta.',
      errorSave8: 'Debe seleccionar las respuestas correcta.',
      errorSave9: 'Debe subir un archivo, foto, video, etc.',
      messageResponse: 'Seleccione la respuesta correcta',
      errorDeleteQuestion: 'Debe existir minimo una pregunta',
      errorDeleteOption: 'Debe existir minimo dos tipos de respuesta',
      confirmDeleteOption: '¿Esta seguro de eliminar esta respuesta ?',
      confirmDeleteQuestion: '¿Esta seguro de eliminar esta pregunta?',
      sendCampaing: '¿Esta seguro de guardar la campaña?',
      successMessage: 'Se guardo la campaña correctamente',
      detailCampaigns: 'Detalle de la campaña',
      UsersWhoHaveAnswered: 'Usuarios que han Contestado',
      ActiveUsers: 'Usuarios activos durante la encuesta: ',
      originalImage: 'Imagen original',
      userResponses: 'Respuestas de los usuarios',
      listOfAnswers: 'Listado de respuestas',
      responseMap: 'Mapa de respuestas',
      listUsers: 'Listado de usuarios que contestaron la encuesta',
      load: 'Cargando...',
      responses: 'Respuestas',
      listType: {
        Survey: 'Encuesta',
        Form: 'Formulario',
        Training: 'Entrenamiento',
        Announcement: 'Anuncio',
        PhotoWithLocation: 'Foto con ubicación',
        none: 'ninguno',
      },
      listDivision: {
        Marketing: 'Mercadeo',
        Sales: 'Ventas',
        Finance: 'Finanzas',
      },
      filterByName: 'Filtrar por Nombre',
      listTypePublish: {
        Post: 'Publicar',
        postNow: 'Publicar Ahora',
        SchedulePublication: 'Programar Publicación',
        SaveDraft: 'Guardar Borrador',
        SaveTemplate: 'Guardar Template',
        periódicamente: 'Periódicamente',
        save: 'Guardar',
      },
      SelectSavedCampaign: 'Seleccione Campaña Guardada',
      SelectTemplate: 'Seleccione un Template',
      radioSelect: {
        1: 'Crear campaña nueva',
        2: 'Crear un template',
        3: 'Crear campaña en base a un template',
        4: 'Continuar con una campaña guardada',
      },
      existeImage: 'ya existe una  Imagen para esta campaña',
      TotalsInPoints: 'Total en Puntos',
      TotalsInMoney: 'Total en Dinero',
      EarnPoints: 'Gana puntos: ',
      WithFaceRecognition: 'Con reconocimiento de rostro',
      WithIDRecognition: 'Con reconocimiento de identificación',
      WithoutFaceRecognition: 'Sin servicios cognitivos',
      SelectImageFace: 'Subir imagen de rostro humano.',
      errorImage: {
        one: 'La imagen no es una cara',
        two: 'Solo debe haber una cara en la imagen',
      },
      idendifiedPercentage: 'Porcentaje Identificado',
      isIdendified: 'Es Identificado',
      daysJson: {
        1: 'Cada Día',
        2: 'Cada 2 Días',
        3: 'cada 3 Días',
        4: 'Cada 4 Días',
        5: 'Cada 5 Días',
        6: 'Cada 6 Días',
        7: 'Cada 7 Días',
        8: 'Cada 8 Días',
        9: 'Cada 9 Días',
        10: 'Cada 10 Días',
        11: 'Cada 11 Días',
        12: 'Cada 12 Días',
        13: 'Cada 13 Días',
        14: 'Cada 14 Días',
        15: 'Cada 15 Días',
        16: 'Cada 16 Días',
        17: 'Cada 17 Días',
        18: 'Cada 18 Días',
        19: 'Cada 19 Días',
        20: 'Cada 20 Días',
        21: 'Cada 21 Días',
        22: 'Cada 22 Días',
        23: 'Cada 23 Días',
        24: 'Cada 24 Días',
        25: 'Cada 25 Días',
        26: 'Cada 26 Días',
        27: 'Cada 27 Días',
        28: 'Cada 28 Días',
        29: 'Cada 29 Días',
        30: 'Cada 30 Días',
        31: 'Cada 31 Días',
      },
      successBien: 'Se elimino la campaña correctamente.',
    },
    users: {
      SelectGroup: 'Seleccione el grupo',
      addUsersByCsv: 'Subir usuarios por CSV',
      titleModal: 'Agregar usuarios por CSV',
      modalMessageOne: 'Haga clic o arrastre el archivo a esta área para subir',
      modalMessageTwo: 'Subir únicamente archivos CSV',
      filterByDate: 'Filtrar por Usuarios Activos',
      ListOfUsers: 'Listado de Usuarios',
      points: 'Puntos',
      Detail: 'Detalle',
      tableNames: {
        access: 'Acceso',
        Registry: 'Registro',
        name: 'Nombre',
        Telephone: 'Teléfono',
        status: 'Estado',
        deleteUser: 'Eliminar',
      },
      enterpriseFilter: 'filtrar por empresa',
      edit: 'Editar',
    },
    Payments: {
      PaidOrders: 'Órdenes Pagadas:',
      TotalValuePaid: 'Valor Total Pagado',
      AverageValuePaid: 'Valor Promedio Pagado',
      ListOfTransactions: 'Listado de las Transacciones',
      WithCard: 'Con tarjeta',
      WithPoints: 'With points',
      tableNames: {
        amount: 'Total',
        invoiceNumber: 'Número de Factura',
        invoiceStatus: 'Estado de la Factura',
        payed_points: 'Puntos',
        payed_money: 'Monto',
      },
      FilterByInvoiceNumber: 'Filtrar por Número de Factura',
      error: 'No existe el número de factura',
      printScv: 'Exportar CSV',
    },
    groupsDetail: {
      Campaigns_in_the_group: 'Campañas en el grupo',
      ListOfGroups: 'Listado de Grupos',
      TotalCampaigns: 'Total campañas',
      TotalUsers: 'Total de usuarios',
      tableNames: {
        name: 'Nombre',
        type: 'Tipo',
        createdAt: 'Creado en',
        expiration_date: 'Fecha de caducidad',
        budget: 'Presupuesto',
        budget_remaining: 'Presupuesto restante',
        earn_points: 'Gana puntos',
        suscribers_answered: 'Suscriptores respondieron',
        number_of_suscribers_in_group: 'Suscriptores en Grupo',
        updatedAt: 'Actualizado en',
        status: 'Estado',
      },
      total_suscribers_answered_by_group: 'Total de respuestas por grupo',
      total_campaigns_by_group: 'campañas totales por grupo',
      filterByGroup: 'Filtrar por grupo',
      NewGroup: 'Agregar Grupo',
      addUsers: 'Agregar usuarios',
      downloadUsers: 'Descargar listado de usuarios en CSV',
      detail: 'Detalle',
      addKaizalaID: 'Agregar grupo de kaizala',
      selectID: 'Por favor seleccione una opcion',
      addKaizalaGroup: 'Grupo',
      campaing: 'Campañas',
      AddMiniAppTitle: 'Agregar miniApp al grupo',
      AddMiniAppButton: 'Agregar miniApp',
      selectMiniApp: 'Seleccione la miniApp',
      invoice: 'Pago Factura',
      errorAddMiniApp: 'Debe seleccionar una miniApp para agregarla al grupo.',
      add: 'Agregar',
      addMiniappSuccess: 'Se agrego la miniApp al grupo exitosamente.',
      addMiniappError: 'Hubo un error al intentar agregar la  miniApp al grupo.',
    },
    addGroup: {
      selectIcon: 'Seleccione una imagen',
      GroupName: 'Nombre de grupo',
      briefDescription: 'Descripción breve',
      LongDescription: 'Descripción larga',
      WelcomeMessage: 'Mensaje de bienvenida',
      requireMesage: 'Por favor ingrese los datos',
      Register: 'Registrar',
      UploadIcon: 'Subir icono del grupo',
      errorImage: 'Debe seleccionar una imagen para el icono del grupo',
      success: 'Se ha agregado el nuevo gupo con exito',
    },
    addUser: {
      success: 'Se agrego el usuario exitosamente',
      errorMessage: 'El grupo no es público, no se pueden agregar usuarios.',
      title: 'Agregar usuarios',
      save: 'Guardar',
      Number: 'Número de celular',
      required: 'Por favor ingrese su número de teléfono!',
      addKaizalaIdSuccess: 'Se agrego el id de kaizala con exito.',
      codigoZap: 'Código SAP',
    },
    SuppliersPage: {
      companyListing: 'Listado de empresa',
      tableNames: {
        name: 'Nombre',
        createdAt: 'Creado en',
        updatedAt: 'Actualizado en',
      },
    },
    createSuppliers: {
      addProvider: 'Agregar un proveedor',
      providerName: 'Nombre',
      requireMesage: 'Por favor ingrese los datos',
      Register: 'Registro',
      notValidEmail: 'La entrada no es válida por correo electrónico!',
      enterpriseName: 'Nombre de empresa',
      UploadIcon: 'Subir icono de empresa',
      selectIcon: 'Seleccione una imagen',
      success: 'se he creado la empresa exitosamente',
      errorImage: 'Debe seleccionar una imagen para el icono de la empresa',
    },
    division: {
      title: 'Listado de Centro de Costos',
      title2: 'Centro de Costos',
      addDivision: 'Agregar',
      successMessage: 'Se guardo correctamente',
      errorSeve: 'hubo un error al guardar, intente nuevamente.',
      modal: {
        save: 'Guardar',
        nameDivision: 'Nombre',
      },
    },
    setings: {
      title: 'Ajustes',
      pointEquivalence: 'Equivalencia de Puntos',
      filterDefault: 'Filtro por Defecto',
      changeFilter: 'Cambiar filtro',
      Points: 'Puntos',
      save: 'Guardar',
      titleModal: 'Editar valor de la equivalencia',
      Register: 'Cambiar equivalencia',
      filter: 'Filtro',
      notHaveOneByDefault: 'Aun no tienes uno por defecto',
      text1: 'Un Punto Equivale a: ',
    },
    templates: {
      title: 'Listado de Templates',
      titleSaveCampaing: 'Listado de Campañas Guardadas',
      titleScheduledCampaigns: 'Listado de Campañas Programadas',
      tableNames: {
        name: 'Nombre',
        createdAt: 'Creado en',
        type: 'Tipo',
        publish_date: 'Fecha de Publicación',
        hours: 'Hora',
        division: 'Centro de Costo',
      },
      deleteTemplate: '¿Desea eliminar este template?',
      deleteSaveCampaing: '¿Desea eliminar esta Campaña guardada?',
    },
    categories: {
      title: 'Listado de categorias',
      add: 'Crear Categoria',
      form: {
        name: 'Nombre',
        points: 'Puntos',
        errorRequired: 'Este dato es requerido',
      },
      successMessage: 'Se guardo la categoria correctamente',
      category: 'Categoria',
      addUserToCategory: 'Agregar Categoria',
      editCategory: 'Editar Categoria',
      addCategoryByUser: 'Agregar Categoría a Usuario',
      SuccessMessage: 'Se agrego la categoría con exito',
      errorMessage: 'En este momento no se puede agregar la categoría, intente mas tarde.',
    },
  },

  port: {
    application: {
      Ingles: 'Ingles',
      Español: 'Español',
      portugues: 'portugues',
      ShowMore: 'Mostrar Mais',
      showLess: 'Mostrar Menos',
      CreateCampaign: 'Criar campanha',
      titleAdmin: 'Administrador tling v1.6.5',
      title: 'Campanha ACME',
      email: 'E-mail ',
      SignOff: 'Sair',
      LogIn: 'Entrar',
      mainManu: {
        dashboard: 'Painel de Controle',
        campaigns: 'Campanhas',
        users: 'Usuários',
        payments: 'Pagamentos',
        Groups: 'Grupos',
        DetailGroups: 'Detalhe do grupo',
        Suppliers: 'Fornecedores',
        Setings: 'Ajustes',
        campaignsSave: 'Rascunho',
        scheduledCampaigns: 'Campanhas Programadas',
        categories: 'Categories',
      },
      changePassword: 'Mudas senha',
      DashboardCampañas: 'Painel de Controle de Campanhas',
      yes: 'Sim',
    },
    changePassword: {
      changePassword: 'Mudar senha',
      text: 'Nessa sessão você pode alterar sua senha',
      previousPassword: 'Digite a senha anterior',
      requireMesage: 'Por favor, insira os dados',
      newPassword: 'Digite a nova senha',
      RepeatPassword: 'Repita a nova senha',
      save: 'Salvar a nova senha',
      inconsistentPass: 'As duas senhas inseridas são divergentes',
      alertSuccess: 'A senha foi alterada corretamente',
      errorSeve: 'Houve um erro ao mudar a senha. Tente novamente.',
    },
    DashboardTling: {
      Efectividad: 'Efetividade',
      PaymentsByDate: 'Pagamentos por Data',
      Bells: 'Campanhas',
      TotalCampaignsOfTheMonth: 'Total de campanhas do mês',
      TotalCampaignsFromTheStart: 'Total de campanhas desde o início do ano até a data atual',

      Points: 'Pontos',
      PointsDelivered: 'Entregues',
      TotalPointsEarnedFromMonth: 'Total de pontos ganhados no mês',
      TotalPointsEarnedFromTheBeginning:
        'Total de pontos ganhados desde o início do ano até a data atual',
      RedeemedPoints: 'Resgatados',
      TotalPointsRedeemedFromMonth: 'Total de pontos resgatados no mês',
      TotalPointsRedeemedFromTheBeginning:
        'Total de pontos resgatados desde o início do ano até a data atual',
      TotalPaidInvoicesOfTheMonth: 'Total de faturas',
      Invoices: 'Facturas',
      Activeusers: 'Usuários Ativos',
      NoActiveusers: 'Usuários Inativos',
      TotalInvoicesPaidFromTheBeginning:
        'Total de faturas pagas desde o iniício do ano até a data atual',
      TotalBill: 'Total de pontos em pesos gastos por dia',
      TotalPaidWithMoney: 'Total de pontos gastos por dia',
      TotalPaidWithPoints: 'Total de pontos ganhados por dia',
      TotalCampaigns: 'Total de campanhas',
      TotalPointsEarned: 'Total de pontos ganhados',
      TotalPointsRedeemed: 'Total de pontos resgatados',
      TotalInvoices: 'Número de Faturas',
      TotalInvoices2: 'Total de Facturas',
      days: {
        Monday: 'Segunda-feira',
        Tuesday: 'Terça-feira',
        Wednesday: 'Quarta-feira',
        Thursday: 'Quinta-feira',
        Friday: 'Sexta-feira',
        Saturday: 'Sábado',
        Sunday: 'Domingo',
      },
      typeSurvey: 'Tipo de Campanha',
      tableOne: {
        position: 'Cargo',
        name: 'Nome',
        Effectiveness: 'Efetividade',
      },
    },
    SurveysAdmin: {
      helmetTitle: 'Usuário',
      ListOfCampaigns: 'Lista de Campanhas',
      FilterByType: 'Filtrar por Tipo',
      FilterByTypeDivision: 'Filtrar por Centro de Custo',
      filter: {
        none: 'Nenhum',
        all: 'Todos',
        Survey: 'Pesquisa',
        Training: 'Treinamento',
      },
      FilterByDateRange: 'Filtro por Rango de Fecha',
      FilterByDateRangeStartEnd: 'Filtrar por data de início e data final',
      filterData: {
        select: 'Selecione...',
        currentMonth: 'Mês atual',
        currentYear: 'Ano atual',
        eight: 'Últimos 8 dias',
        thirty: 'Últimos 30 dias',
        ninety: 'Últimos 90 dias',
        eighty: 'Últimos 180 Días',
        one: 'Ano anterior',
        personalized: 'Personalizado',
      },
      filterText: 'Filtrar',
      TypeOfCampaign: 'Tipo de Campanha',
      photoWithLocationPhoto: 'Tipo',
      Equivalencia: 'Equivalência: ',
      publishType: 'Tipo de publicação',
      NewCampaign: 'Nova Campanha',
      NewCampaign2: 'Novo template',
      NewCampaign3: 'Campanha salva',
      NewCampaign4: 'template',
      NewCampaign5: 'Nova Campanha',
      NewCampaign8: 'Campanha agendada',
      group: 'Grupo',
      name: 'Nome da Campanha',
      Description: 'Descrição',
      Budget: 'Orçamento em pontos',
      ValuePerResponse: 'Valor por resposta em pontos',
      UploadCampaignIcon: 'Adicione o ícone da campanha',
      UploadNewCampaignIcon: 'Mudar ícone da campanha',
      UploadFileForContent: 'Adicione o arquivo para o conteúdo',
      UploadFileForQuestion: 'Adicione a imagem para a pergunta',
      expirationDate: 'Data de validade: ',
      PublishDate: 'Dias de Publicação',
      daysPublish: 'Dias de Publicação: ',
      Questions: 'Perguntas',
      Contents: 'Conteúdos',
      NewQuestion: 'Nova Pergunta',
      SaveCampaign: 'Salvar campanha',
      Cancel: 'Cancelar',
      PreguntaNumber: 'Pergunta',
      Content: 'Conteúdo',
      EnterQuestion: 'Insira uma pergunta',
      text1: 'Texto',
      TypeOfResponse: 'Tipo de resposta',
      TypeOfContent: 'Tipo de conteúdo',
      typeQuestion: {
        MultiOption: 'Múltipla escolha',
        SingleOption: 'Única escolha',
        Text: 'Resposta de texto',
        Number: 'Resposta numérica',
        Phone: 'Número de telefone',
        Image: 'Imagem',
        TextM: 'Texto',
      },
      save: 'Salvar',
      tableNames: {
        type: 'Tipo',
        name: 'Nome',
        DateOfExpiry: 'Data de Expiração',
        Budget: 'Orçamento',
        RemainingBudget: 'Orçamento Restante',
        EarnPoints: 'Ganhe Pontos',
        equivalenceMoney: 'Equivalência em Dinheiro',
      },
      training: 'Treinamento',
      Survey: 'Pesquisas',
      DetailOfTheBalance: 'Detalhe do saldo',
      detailSurvey: {
        Updated: 'Atualizado',
        name: 'Nome',
        phoneNumber: 'Número telefônico',
      },
      detailTable: {
        Updated: 'Atualizado',
        image: 'Imagem',
        name: 'Nome',
        TotalPoints: 'Total de pontos',
      },
      NewAnswer: 'Adicionar uma nova resposta',
      saveLocalStorage: 'Deseja salvar a campanha para continuar mais tarde?',
      continueCampaign: 'Continuar a campanha previamente criada',
      errorSave: 'É necessário que tenha pelo menos duas opções',
      errorSave2: 'Erro. Debe inserir todos os dados',
      errorSave3: 'Erro. Debe salvar todas as perguntas antes de salvar a campanha.',
      errorSave4: 'Erro. Não foi possível salvar a campanha',
      errorSave5: 'A data de publicação não deve ser maior que a data de expiração',
      errorSave6: 'Aguarde enquanto termina de carregar a imagem...',
      errorSave7: 'Selecione  a resposta correta',
      errorSave8: 'Selecione as respostas corretas.',
      errorSave9: 'Você deve fazer o upload de um arquivo, foto, vídeo, etc',
      messageResponse: 'Selecione a resposta correta',
      errorDeleteQuestion: 'É necessário ter no mínimo uma pergunta',
      errorDeleteOption: 'É necesspario ter no mínimo dois tipo de resposta',
      confirmDeleteOption: 'Tem certeza que deseja excluir essa resposta?',
      confirmDeleteQuestion: 'Tem certeza que deseja excluir essa pergunta?',
      sendCampaing: 'Tem certeza que deseja salvar a campanha?',
      successMessage: 'Campanha salvada corretamente',
      detailCampaigns: 'Detalhe da campanha',
      UsersWhoHaveAnswered: 'Usuários que responderam',
      ActiveUsers: 'Usuários ativos durante a pesquisa: ',
      originalImage: 'Imagem original',
      userResponses: 'Resposta dos usuários',
      listOfAnswers: 'Lista de respostas',
      responseMap: 'Mapa de resposta',
      listUsers: 'Lista de usuários que responderam a pesquisa',
      load: 'Carregando...',
      responses: 'Respostas',
      listType: {
        Survey: 'Pesquisa',
        Form: 'Formulário',
        Training: 'Treinamento',
        Announcement: 'Anúncio',
        PhotoWithLocation: 'Foto com a localização',
        none: 'Nenhum',
      },
      listDivision: {
        Marketing: 'Marketing',
        Sales: 'Vendas',
        Finance: 'Finanças',
      },
      filterByName: 'Filtrar por Nome',
      listTypePublish: {
        Post: 'Publicas',
        postNow: 'Publicar agora',
        SchedulePublication: 'Programar Publicação',
        SaveDraft: 'Salvar rascunho',
        SaveTemplate: 'Salvar template',
        save: 'Salvar',
        periódicamente: 'Periodicamente',
      },
      SelectSavedCampaign: 'Selecione Campanha Salvada',
      SelectTemplate: 'Selecione um Template',
      radioSelect: {
        1: 'Criar uma nova campanha',
        2: 'Criar um template',
        3: 'Criar campanha baseada em um template',
        4: 'Continuar com a campanha salvada',
      },
      existeImage: 'Já existe uma imagem para esta campanha',
      TotalsInPoints: 'Total em Pontos',
      TotalsInMoney: 'Total em Dinheiro',
      EarnPoints: 'Ganhe pontos: ',
      WithFaceRecognition: 'Com reconhecimento facial',
      WithIDRecognition: 'Com reconhecimento de identificação',
      WithoutFaceRecognition: 'Sem serviços cognitivos',
      SelectImageFace: 'Adicione imagem de rosto humano.',
      errorImage: {
        one: 'A imagem não é um rosto',
        two: 'Só deve ter um rosto na imagem',
      },
      idendifiedPercentage: 'Porcentagem Identificada',
      isIdendified: 'É identificado',
      daysJson: {
        1: 'Cada Dia',
        2: 'Cada 2 Dias',
        3: 'cada 3 Dias',
        4: 'Cada 4 Dias',
        5: 'Cada 5 Dias',
        6: 'Cada 6 Dias',
        7: 'Cada 7 Dias',
        8: 'Cada 8 Dias',
        9: 'Cada 9 Dias',
        10: 'Cada 10 Dias',
        11: 'Cada 11 Dias',
        12: 'Cada 12 Dias',
        13: 'Cada 13 Dias',
        14: 'Cada 14 Dias',
        15: 'Cada 15 Dias',
        16: 'Cada 16 Dias',
        17: 'Cada 17 Dias',
        18: 'Cada 18 Dias',
        19: 'Cada 19 Dias',
        20: 'Cada 20 Dias',
        21: 'Cada 21 Dias',
        22: 'Cada 22 Dias',
        23: 'Cada 23 Dias',
        24: 'Cada 24 Dias',
        25: 'Cada 25 Dias',
        26: 'Cada 26 Dias',
        27: 'Cada 27 Dias',
        28: 'Cada 28 Dias',
        29: 'Cada 29 Dias',
        30: 'Cada 30 Dias',
        31: 'Cada 31 Dias',
      },
      successBien: 'Campanha eliminada corretamente.',
    },
    users: {
      SelectGroup: 'Selecione o grupo',
      addUsersByCsv: 'Adicionar usuários por CSV',
      titleModal: 'Adicionar usuários por CSV',
      modalMessageOne: 'Faça um clic ou arraste o arquivo nessa área para adicionar',
      modalMessageTwo: 'Adicionar somente arquivos CSV',
      filterByDate: 'Filtrar por Usuários Ativos',
      ListOfUsers: 'Lista de Usuários',
      points: 'Pontos',
      Detail: 'Detalhe',
      tableNames: {
        access: 'Acesso',
        Registry: 'Cadastro',
        name: 'Nome',
        Telephone: 'Telefone',
        status: 'Status',
        deleteUser: 'Delete',
      },
      enterpriseFilter: 'Filtrar por empresa',
      edit: 'Editar',
    },
    Payments: {
      PaidOrders: 'Pedidos pagos:',
      TotalValuePaid: 'Valor total pago',
      AverageValuePaid: 'Média de Valor Pago',
      ListOfTransactions: 'Lista de Transações',
      WithCard: 'Com cartão de crédito',
      WithPoints: 'Com pontos',
      tableNames: {
        amount: 'Total',
        invoiceNumber: 'Número da fatura',
        invoiceStatus: 'Status da Fatura',
        payed_points: 'Pontos',
        payed_money: 'Quantidade',
      },
      FilterByInvoiceNumber: 'Filtrar por Número de Fatura',
      error: 'Não existe esse número de fatura',
      printScv: 'Exportar CSV',
    },
    groupsDetail: {
      Campaigns_in_the_group: 'Campanhas no grupo',
      ListOfGroups: 'Lista de Grupos',
      TotalCampaigns: 'Total de campanhas',
      TotalUsers: 'Total de usuários',
      tableNames: {
        name: 'Nome',
        type: 'Tipo',
        createdAt: 'Criado em',
        expiration_date: 'Data de expiração',
        budget: 'Orçamento',
        budget_remaining: 'Orçamento restante',
        earn_points: 'Ganhe pontos',
        suscribers_answered: 'Assinantes responderam',
        number_of_suscribers_in_group: 'Assinantes no grupo',
        updatedAt: 'Atualizado em',
        status: 'Status',
      },
      total_suscribers_answered_by_group: 'Total de respostas por grupo',
      total_campaigns_by_group: 'Campanhas totais por grupo',
      filterByGroup: 'Filtrar por grupo',
      NewGroup: 'Adicionar grupo',
      addUsers: 'Adicionar usuários',
      downloadUsers: 'Baixar lista de usuários em CSV',
      detail: 'Detalhe',
      addKaizalaID: 'Adicionar grupo de Kaizala',
      selectID: 'Por favor, selecione uma opção',
      addKaizalaGroup: 'Grupo',
      campaing: 'Campanhas',
      AddMiniAppTitle: 'Adicionar mini app ao grupo',
      AddMiniAppButton: 'Adicionar mini app',
      selectMiniApp: 'Selecione um mini app',
      invoice: 'Pagamento da Fatura',
      errorAddMiniApp: 'Deve selecionar um mini app para adicionar ao grupo.',
      add: 'Adicionar',
      addMiniappSuccess: 'Adicionado o mini app ao grupo com sucesso.',
      addMiniappError: 'Houve um erro ao tentar adicionar o mini app ao grupo.',
    },
    addGroup: {
      selectIcon: 'Selecione uma imagem',
      GroupName: 'Nome do grupo',
      briefDescription: 'Descrição pequena',
      LongDescription: 'Descrição grande',
      WelcomeMessage: 'Mensagem de boas vindas',
      requireMesage: 'Por favor, insira os dados',
      Register: 'Cadastrar',
      UploadIcon: 'Adicionar ícone do grupo',
      errorImage: 'Selecione uma imagem para o ícone do grupo',
      success: 'Foi adicionado um novo grupo',
    },
    addUser: {
      success: 'Foi adicionado o usuário ',
      errorMessage: 'O grupo não é público. Não é possível adicionar usuários.',
      title: 'Adicionar usuários',
      save: 'Salvar',
      Number: 'Número de celular',
      required: 'Por favor, insira seu número de telefone!',
      addKaizalaIdSuccess: 'Foi adicionado o ID de Kaizala com sucesso.',
      codigoZap: 'Código Zap',
    },
    SuppliersPage: {
      companyListing: 'Lista de empresa',
      tableNames: {
        name: 'Nome',
        createdAt: 'Criado em',
        updatedAt: 'Atualizado em',
      },
    },
    createSuppliers: {
      addProvider: 'Adicionar um fornecedor',
      providerName: 'Nome',
      requireMesage: 'Por favor, insira os dados',
      Register: 'Cadastro',
      notValidEmail: 'O acesso não é válido por e-mail',
      enterpriseName: 'Nome da empresa',
      UploadIcon: 'Adicionar ícone da empresa',
      selectIcon: 'Selecione uma imagem',
      success: 'Foi criado uma empresa ',
      errorImage: 'Selecione uma imagem para o ícone da empresa',
    },
    division: {
      title: 'Listra de Centro de Custo',
      title2: 'Centro de Custo',
      addDivision: 'Adicionar',
      successMessage: 'Salvo corretamente',
      errorSeve: 'Houve um erro ao salvar. Tente novamente',
      modal: {
        save: 'Salvar',
        nameDivision: 'Nome',
      },
    },
    setings: {
      title: 'Ajuster',
      pointEquivalence: 'Equivalência de Pontos',
      filterDefault: 'Filtro por padrão',
      changeFilter: 'Mudar filtro',
      Points: 'Pontos',
      save: 'Salvar',
      titleModal: 'Editar valor  de equivalência',
      Register: 'Mudar equivalência',
      filter: 'Filtro',
      notHaveOneByDefault: 'Ainda não tem um por padrão',
      text1: 'Um Ponto Equivale a: ',
    },
    templates: {
      title: 'Lista de Templates',
      titleSaveCampaing: 'Lista de Campanhas Salvas',
      titleScheduledCampaigns: 'Lista de Campanhas Programadas',
      tableNames: {
        name: 'Nome',
        createdAt: 'Criado em',
        type: 'Tipo',
        publish_date: 'Data de Publicação',
        hours: 'Hora',
        division: 'Centro de Custo',
      },
      deleteTemplate: 'Deseja excluir esse template?',
      deleteSaveCampaing: 'Deseja excluir essa Campanha salvada?',
    },
    categories: {
      category: 'Categoria',
      title: 'Lista de categorias',
      add: 'Crear categoría',
      form: {
        name: 'Primeiro nome',
        points: 'Pontos',
        errorRequired: 'Esses dados são obrigatórios.',
      },
      successMessage: 'A categoría foi salva corretamente',
      addUserToCategory: 'Adicionar Categoria',
      editCategory: 'Editar Categoria',
      addCategoryByUser: 'Adicionar categoria ao usuário',
      SuccessMessage: 'A categoria foi adicionada com sucesso',
      errorMessage: 'Neste momento a categoria não pode ser adicionada, tente mais tarde.',
    },
  },
}



// WEBPACK FOOTER //
// ./src/translate/translate.js